
import React, { useState , useEffect } from "react";
import "../../css/Party.css";
import { createPortal } from "react-dom";
import { showSuccess, showError,showWarning} from "../../General/Toast";
import axios from 'axios'
import DeleteConfirmation from "../../General/DeleteConfirmation";
import {
  FaSearch,
  FaPlus,
  FaUsers,
  FaEdit,
  FaTrash,
  FaEye
} from "react-icons/fa";

const Party = ({clientData,appTheme}) => {
  const [showPartyForm, setShowPartyForm] = useState(false);
   const [searchTerm, setSearchTerm] = useState('');
         const [isEditMode, setIsEditMode] = useState(false);
            const [editingCompanyId, setEditingCompanyId] = useState(null);
    const[party,setParty] = useState([]);   
    const [showDelete, setShowDelete] = useState(false);   
    const [selectedParty, setSelectedParty] = useState(null);
    const [showTxn, setShowTxn] = useState(false);
const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");
console.log(appTheme)

const [showPaymentModal, setShowPaymentModal] = useState(false);

const [selectedTransaction, setSelectedTransaction] = useState(null);

const [paymentData, setPaymentData] = useState({
  date: new Date().toISOString().split("T")[0],
  amount: "",
  payment_method: ""
});
const customerDue = Array.isArray(party)
  ? party
      .filter((item) => String(item.p_type) == "Customer")
      .reduce(
        (total, item) =>
          total + Number(item.total_due || item.balance || 0),
        0
      )
  : 0;

const partyDue = Array.isArray(party)
  ? party
      .filter((item) => String(item.p_type).toLowerCase() === "party")
      .reduce(
        (total, item) =>
          total + Number(item.total_due || item.balance || 0),
        0
      )
  : 0;
  

const [paymentLoading, setPaymentLoading] = useState(false);

const [transactions, setTransactions] = useState([]);

const openReceivePayment = (transaction) => {

  setSelectedTransaction(transaction);

  setPaymentData({
    date: new Date().toISOString().split("T")[0],
    amount: "",
    payment_method: ""
  });

  setShowPaymentModal(true);
};

    const [formData, setFormData] = useState({
       name:'',
    first_visit:'',
    last_visit:'',
    mobile:'',
    email:"",
    total_pur:"",
    total_due:"",
    loyality:'',
    visits:"",
    gstin:'',
    gst_type:"Registered",
    gst_state:'',
    address:'',
    history:'',
    opening_balance:'',
    opening_bal_status:'',
    balance:'',
    asOfDate:'',
    p_type:'',
    client_id:'' 
      });
      


//         const handleInputChange = (e) => {
//   const { name, value } = e.target;

//   setFormData(prev => {
//     const updated = { ...prev, [name]: value };

//     return updated;
//   });
// };
const handleInputChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => {
    const updated = {
      ...prev,
      [name]: value,
    };

    // Unregistered select karte hi GST related fields clear
    if (name === "gst_type" && value === "Unregistered") {
      updated.gstin = "";
      updated.gst_state = "";
      updated.address = "";
    }

    return updated;
  });
};
const today = new Date().toISOString().split("T")[0];


const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.name || !formData.mobile) {
    showWarning("Name and Mobile are required!", "danger");
    return;
  }

  try {
    const today = new Date().toISOString().split("T")[0];


    const sendData = {
      name: formData.name,
      mobile: formData.mobile,
      gstin: formData.gstin,
      email: formData.email,
      gst_type: formData.gst_type,
      gst_state: formData.gst_state,
      address: formData.address,
      opening_balance: formData.opening_balance,
      asOfDate: formData.asOfDate,
      p_type: "Party",
      client_id: clientData.id,
      first_visit: today,
      last_visit: today,
      total_pur:0,
      total_due:0,
      loyality:0,
      visits:0,
      opening_bal_status:'',
      balance:0,
         };

    let res;

    // 🔥 EDIT MODE
    if (isEditMode) {

        const updateData = {
    name: formData.name,
    mobile: formData.mobile,
    gstin: formData.gstin,
    email: formData.email,
    gst_type: formData.gst_type,
    gst_state: formData.gst_state,
    address: formData.address,
  };

      res = await axios.put(
        `https://api.dectwinbilling.com/edit-party/${formData.id}`,
       updateData
      );

      showSuccess("Party Updated Successfully!", "success");
    } else {
      // 🔥 ADD MODE
      res = await axios.post(
        "https://api.dectwinbilling.com/add-party",
        sendData
      );

      showSuccess("Party Added Successfully!", "success");
    }

    // reset
    setIsEditMode(false);
    resetForm();
    setShowPartyForm(false);
    fetchparty();

  } catch (err) {
    console.error("❌ Error:", err.response?.data || err.message);

    showError(
      err.response?.data?.message || "Failed to save party!",
      "danger"
    );
  }
};

const handleEdit = (form) => {

  setIsEditMode(true);
  setShowPartyForm(true);

  setFormData({
    id: form.id,
    name: form.name || "",
    mobile: form.mobile || "",
    email: form.email || "",
    gstin: form.gstin || "",
    gst_type: form.gst_type || "",
    gst_state: form.gst_state || "",
    address: form.address || "",
    opening_balance: form.opening_balance || "",
    asOfDate: form.as_of_date || "",
  });
};
    const fetchparty = async () => {
    try {
      const res = await axios.get(`https://api.dectwinbilling.com/fetch-party/${clientData.id}`);
      console.log(res.data, "PARTY");
      setParty(res.data);
     
    } catch (error) {
      console.log(error);
    }
  };



  useEffect(() => {
   fetchparty();

  }, []);

  const handleDelete = async (p) => {
  try {
    await axios.delete(`https://api.dectwinbilling.com/delete-party/${selectedParty.id}/${selectedParty.mobile}/${clientData.id}`);

    setShowDelete(false);
    showSuccess("Party deleted successfully!", "success");

    fetchparty(); 
  } catch (err) {
    console.log(err);
    showError("Failed to delete party", "danger");
  }
};

const fetchTransactions = async (
  clientId,
  mobile,
  partyId,
  from = "",
  to = ""
) => {
  try {
    // Default date range = all records
    const startDate = from || "2000-01-01";
    const endDate = to || "2099-12-31";



    const purchaseRes = await axios.get(
      "https://api.dectwinbilling.com/api/get-purchase-data",
      {
        params: {
          client_id: clientId,

          // IMPORTANT:
          // Your backend calls this "mobile"
          // but uses it as party_id.
          mobile: partyId,

          fromDate: startDate,
          toDate: endDate
        }
      }
    );

    // ============================
    // SALES
    // ============================

    const salesRes = await axios.get(
      "https://api.dectwinbilling.com/api/get-sales-data",
      {
        params: {
          client_id: clientId,

          // IMPORTANT
          mobile: partyId,

          fromDate: startDate,
          toDate: endDate
        }
      }
    );

    // ============================
    // DUE HISTORY
    // ============================

    const dueRes = await axios.get(
      "https://api.dectwinbilling.com/due-history-data",
      {
        params: {
          client_id: clientId,
          party_id: partyId,
          fromDate: startDate,
          toDate: endDate
        }
      }
    );



    const purchases = (purchaseRes.data || []).map(item => ({
      ...item,
      billType: "Purchase",
      total: Number(
        item.total ||
        item.grand_total ||
        item.net_total ||
        0
      ),
      due: Number(item.due || 0),
      status:
        Number(item.due || 0) > 0
          ? "Due"
          : "Paid"
    }));

    // ============================
    // FORMAT SALES
    // ============================

    const sales = (salesRes.data || []).map(item => ({
      ...item,
      billType: "Sale",
      total: Number(
        item.total ||
        item.grand_total ||
        item.net_total ||
        0
      ),
      due: Number(item.due || 0),
      status:
        Number(item.due || 0) > 0
          ? "Due"
          : "Paid"
    }));



    const dueHistory = (dueRes.data || []).map(item => ({
      ...item,
      billType: "Payment",
      total: Number(item.amount || 0),
      due: Number(
        item.due ||
        item.balance ||
        0
      ),
      status:
        Number(
          item.due ||
          item.balance ||
          0
        ) > 0
          ? "Due"
          : "Paid"
    }));



    const mergedTransactions = [
      ...purchases,
      ...sales,
      ...dueHistory
    ];



    mergedTransactions.sort(
      (a, b) =>
        new Date(b.date) - new Date(a.date)
    );

   
    setTransactions(mergedTransactions);

  } catch (error) {
    console.error(
      "Transaction Fetch Error:",
      error.response?.data || error.message
    );

    setTransactions([]);
  }
};


  const filteredData = Array.isArray(party)
  ? party
      .filter((itm) =>
        Object.values(itm).some((val) =>
          String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
      )
  : [];

const resetForm = () => {
    setFormData({
         name:'',
    first_visit:'',
    last_visit:'',
    mobile:'',
    email:"",
    total_pur:"",
    total_due:"",
    loyality:'',
    visits:"",
    gstin:'',
    gst_type:'',
    gst_state:'',
    address:'',
    history:'',
    opening_balance:'',
    opening_bal_status:'',
    balance:'',
    asOfDate:'',
    p_type:'',
    client_id:'' 
    })
  }  


const handleReceivePayment = async () => {
  try {

    if (!selectedTransaction) {
      return;
    }

    const amount = Number(paymentData.amount || 0);

    const due = Number(
      selectedTransaction.due || 0
    );

    // Existing received amount
    const oldReceived = Number(
      selectedTransaction.received || 0
    );

    // New total received after this payment
    const payable = oldReceived + amount;

    // Remaining balance after payment
    const balance = due - amount;


    // =========================
    // VALIDATION
    // =========================

    if (!paymentData.date) {
      alert("Please select payment date");
      return;
    }

    if (!amount || amount <= 0) {
      alert("Please enter payment amount");
      return;
    }

    if (amount > due) {
      alert(
        `Payment cannot be greater than due amount ₹${due.toFixed(2)}`
      );
      return;
    }

    if (!paymentData.payment_method) {
      alert("Please select payment method");
      return;
    }


    // =========================
    // PARTY ID
    // =========================

    const partyId =
      selectedTransaction.party_id ||
      selectedParty?.id;

    if (!partyId) {
      alert("Party ID not found");
      return;
    }


    setPaymentLoading(true);


    // =========================
    // API
    // =========================

    const res = await axios.put(
      `https://api.dectwinbilling.com/adjust-bill/${clientData.id}`,
      {
        partyId: partyId,

        name:
          selectedParty?.name ||
          selectedTransaction.name ||
          "",

        payment_method:
          paymentData.payment_method,

        balance: balance,

        amount: amount,

        payable: payable,

        invoiceNo:
          selectedTransaction.invoiceNo,

        bill_type:
          selectedTransaction.billType,

        history_id:
          selectedTransaction.id,

        receive_date:
          paymentData.date
      }
    );



    alert("Payment received successfully");


    // Close payment modal
    setShowPaymentModal(false);

    setSelectedTransaction(null);


    // Reset form
    setPaymentData({
      date: new Date()
        .toISOString()
        .split("T")[0],

      amount: "",

      payment_method: ""
    });


    // =========================
    // REFRESH TRANSACTIONS
    // =========================

    await fetchTransactions(
      clientData.id,
      selectedParty?.mobile,
      selectedParty?.id,
      fromDate,
      toDate
    );


  } catch (error) {

    console.error(
      "Receive payment error:",
      error.response?.data ||
      error.message
    );

    alert(
      error.response?.data?.error ||
      "Failed to receive payment"
    );

  } finally {

    setPaymentLoading(false);

  }
};

  return (
    <div className="party-container">
      <div className="party-header">
        <h2>Customer & Parties</h2>
         <div className="search-box">
            <FaSearch />
            <input
              type="text"
              placeholder="Search party name..."
                value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
<div className="party-header-right">
  <span className="customer-due">
    Customer Due: ₹ {customerDue.toFixed(2)}
  </span>

  <span className="party-due">
    Party Due: ₹ {partyDue.toFixed(2)}
  </span>

  <button
    className="add-party-btn"
    onClick={() => setShowPartyForm(true)}
  >
    <FaPlus />
    Add Party
  </button>
</div>

        
      </div>

    <div className="table-responsive ">
  <h3 className="">Party List</h3>

  <table className="table  table-hover">
    <thead >
      <tr >
        <th style={{ backgroundColor: "var(--danger)", color: "#fff" }}>SN</th>
        <th style={{ backgroundColor: "var(--danger)", color: "#fff" }}>Name</th>
        <th style={{ backgroundColor: "var(--danger)", color: "#fff" }}>Mobile</th>
        <th style={{ backgroundColor: "var(--danger)", color: "#fff" }}>Email</th>
        <th style={{ backgroundColor: "var(--danger)", color: "#fff" }}>GSTIN</th>
        <th style={{ backgroundColor: "var(--danger)", color: "#fff" }}>Balance</th>

        <th style={{ backgroundColor: "var(--danger)", color: "#fff" }} >Action</th>
      </tr>
    </thead>

    <tbody>
      {filteredData.length === 0 ? (
        <tr>
          <td colSpan="8" className="text-center text-muted">
            No Party Found
          </td>
        </tr>
      ) : (
        filteredData.map((item, index) => (
          <tr key={item.id}>
            <td>{index + 1}</td>
            <td>{item.name}</td>
            <td>{item.mobile}</td>
            <td>{item.email}</td>
            <td>{item.gstin}</td>
            <td>₹ {item.opening_balance || 0}</td>
         

            
<td>
  <div className="d-flex justify-content-center align-items-center gap-2">

    {/* EDIT */}
    <button
      type="button"
      className="btn btn-sm btn-warning d-flex align-items-center justify-content-center"
      onClick={() => handleEdit(item)}
      title="Edit Party"
      style={{
        width: "34px",
        height: "34px",
        padding: 0,
      }}
    >
      <FaEdit size={14} />
    </button>


    {/* DELETE */}
    <button
      type="button"
      className="btn btn-sm btn-danger d-flex align-items-center justify-content-center"
      onClick={() => {
        setSelectedParty(item);
        setShowDelete(true);
      }}
      title="Delete Party"
      style={{
        width: "34px",
        height: "34px",
        padding: 0,
      }}
    >
      <FaTrash size={14} />
    </button>


    {/* VIEW */}
    <button
      type="button"
      className="btn btn-sm btn-info text-white d-flex align-items-center justify-content-center"
      onClick={() => {
        setSelectedParty(item);
        setShowTxn(true);

        fetchTransactions(
          clientData.id,
          item.mobile,
          item.id,
          "",
          ""
        );
      }}
      title="View Party"
      style={{
        width: "34px",
        height: "34px",
        padding: 0,
      }}
    >
      <FaEye size={14} />
    </button>

  </div>
</td>
          </tr>
        ))
      )}
    </tbody>
  </table>
</div>

      <div className="party-content">
{showPartyForm &&
  createPortal(
    <div
      className="party-modal-overlay"
      role="dialog"
      aria-modal="true"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) {
          setShowPartyForm(false);
          setIsEditMode(false);
          resetForm();
        }
      }}
    >
      <div className="party-modal-container">
        <form
          onSubmit={handleSubmit}
          className="party-modal-form"
          onMouseDown={(e) => e.stopPropagation()}
        >

          {/* =====================================================
              HEADER
          ====================================================== */}

          <div className="party-modal-header">

            <div>
              <h5 className="party-modal-title">
                {isEditMode
                  ? "Edit Party"
                  : "Party Details"}
              </h5>

              <span className="party-modal-subtitle">
                {isEditMode
                  ? "Update party information"
                  : "Add new party details"}
              </span>
            </div>

            <button
              type="button"
              className="party-modal-close"
              aria-label="Close"
              onClick={() => {
                setShowPartyForm(false);
                setIsEditMode(false);
                resetForm();
              }}
            >
              <i className="bi bi-x-lg"></i>
            </button>

          </div>


          {/* =====================================================
              BODY
          ====================================================== */}

          <div className="party-modal-body">

            <div className="row g-3">

              {/* =================================================
                  LEFT SECTION
              ================================================= */}

              <div className="col-12 col-md-6">

                {/* PARTY NAME */}

                <div className="party-field">

                  <label>
                    Party Name
                    <span className="required-star">
                      *
                    </span>
                  </label>

                  <div className="party-input-wrapper">

                    <i className="bi bi-person"></i>

                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder="Enter party name"
                      required
                    />

                  </div>

                </div>


                {/* PARTY CONTACT */}

                <div className="party-field">

                  <label>
                    Party Contact
                    <span className="required-star">
                      *
                    </span>
                  </label>

                  <div className="party-input-wrapper">

                    <i className="bi bi-telephone"></i>

                    <input
                      type="text"
                      className="form-control"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleInputChange}
                      placeholder="Enter contact number"
                      required
                      maxLength={10}
                    />

                  </div>

                </div>


                {/* PARTY GSTIN */}

                <div className="party-field">

                  <label>
                    Party GSTIN
                  </label>

                  <div className="party-input-wrapper">

                    <i className="bi bi-card-text"></i>

                    <input
                      type="text"
                      className="form-control"
                      name="gstin"
                      value={formData.gstin}
                      onChange={handleInputChange}
                      placeholder="Enter GSTIN"
                      disabled={
                        formData.gst_type ===
                        "Unregistered"
                      }
                    />

                  </div>

                </div>


                {/* PARTY EMAIL */}

                <div className="party-field">

                  <label>
                    Party Email
                  </label>

                  <div className="party-input-wrapper">

                    <i className="bi bi-envelope"></i>

                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="Enter email address"
                    />

                  </div>

                </div>


                {/* TOTAL PURCHASE */}

                <div className="party-field">

                  <label>
                    Total Purchase
                  </label>

                  <div className="party-readonly-field">

                    <i className="bi bi-cart-check"></i>

                    <span>
                      ₹{" "}
                      {formData.total_pur || 0}
                    </span>

                  </div>

                </div>


                {/* OPENING BALANCE */}

                <div className="party-field">

                  <label>
                    Opening Balance
                  </label>

                  <div className="party-input-wrapper">

                    <i className="bi bi-currency-rupee"></i>

                    <input
                      type="number"
                      className="form-control"
                      name="opening_balance"
                      value={
                        formData.opening_balance
                      }
                      onChange={handleInputChange}
                      placeholder="0.00"
                      disabled={isEditMode}
                    />

                  </div>

                </div>

              </div>


              {/* =================================================
                  RIGHT SECTION
              ================================================= */}

              <div className="col-12 col-md-6">

                {/* GST TYPE */}

                <div className="party-field">

                  <label>
                    GSTIN Type
                  </label>

                  <div className="party-input-wrapper">

                    <i className="bi bi-ui-checks"></i>

                    <select
                      className="form-select"
                      name="gst_type"
                      value={formData.gst_type}
                      onChange={handleInputChange}
                    >
                      <option value="">
                        Select GST Type
                      </option>

                      <option value="Registered">
                        Registered
                      </option>

                      <option value="Unregistered">
                        Unregistered
                      </option>
                    </select>

                  </div>

                </div>


                {/* GST STATE */}

                <div className="party-field">

                  <label>
                    GSTIN State
                  </label>

                  <div className="party-input-wrapper">

                    <i className="bi bi-geo-alt"></i>

                    <input
                      type="text"
                      className="form-control"
                      name="gst_state"
                      value={
                        formData.gst_state
                      }
                      onChange={handleInputChange}
                      placeholder="Enter GST state"
                      disabled={
                        formData.gst_type ===
                        "Unregistered"
                      }
                    />

                  </div>

                </div>


                {/* GST ADDRESS */}

                <div className="party-field">

                  <label>
                    GSTIN Address
                  </label>

                  <div className="party-textarea-wrapper">

                    <i className="bi bi-geo-alt"></i>

                    <textarea
                      className="form-control"
                      name="address"
                      value={
                        formData.address
                      }
                      onChange={handleInputChange}
                      placeholder="Enter GST address"
                      rows="3"
                      disabled={
                        formData.gst_type ===
                        "Unregistered"
                      }
                    />

                  </div>

                </div>


                {/* TOTAL DUE - EDIT */}

                {isEditMode && (
                  <div className="party-field">

                    <label className="due-label">
                      Total Due
                    </label>

                    <div className="party-readonly-field due-field">

                      <i className="bi bi-exclamation-circle"></i>

                      <span>
                        ₹{" "}
                        {formData.total_due ||
                          0}
                      </span>

                    </div>

                  </div>
                )}


                {/* AS OF DATE - ADD */}

                {!isEditMode && (
                  <div className="party-field">

                    <label>
                      As Of Date
                      <span className="required-star">
                        *
                      </span>
                    </label>

                    <div className="party-input-wrapper">

                      <i className="bi bi-calendar3"></i>

                      <input
                        type="datetime-local"
                        className="form-control"
                        name="asOfDate"
                        value={
                          formData.asOfDate
                        }
                        onChange={
                          handleInputChange
                        }
                        required
                      />

                    </div>

                  </div>
                )}

              </div>

            </div>

          </div>


          {/* =====================================================
              FOOTER
          ====================================================== */}

          <div className="party-modal-footer">

            <button
              type="button"
              className="party-cancel-btn"
              onClick={() => {
                setShowPartyForm(false);
                setIsEditMode(false);
                resetForm();
              }}
            >
              <i className="bi bi-x-circle me-2"></i>
              Close
            </button>

            <button
              type="submit"
              className="party-submit-btn"
            >
              <i
                className={
                  isEditMode
                    ? "bi bi-check2-circle me-2"
                    : "bi bi-plus-circle me-2"
                }
              ></i>

              {isEditMode
                ? "Update Details"
                : "Submit Details"}
            </button>

          </div>

        </form>
      </div>
    </div>,

    document.body
  )}
{showTxn && (
  <div
    className="position-fixed top-0 start-0 w-100 h-100"
    style={{
      background: "rgba(0,0,0,0.6)",
      zIndex: 9999,
    }}
  >
    <div
      className="bg-white rounded-4 shadow p-3 mx-auto mt-3"
      style={{
        width: "95%",
        maxWidth: "1000px",
        maxHeight: "95vh",
        overflowY: "auto",
      }}
    >
      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="text-primary m-0">
          {selectedParty?.name}
        </h4>

        <button
          className="btn btn-sm btn-danger"
          onClick={() => setShowTxn(false)}
        >
          Close
        </button>
      </div>

      {/* FILTER */}
      <div className="d-flex justify-content-start flex-wrap gap-2 mb-3">
        <div className="d-flex gap-2">
          <input
            type="date"
            className="form-control form-control-sm"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />

          <input
            type="date"
            className="form-control form-control-sm"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>

 <button
  className="btn btn-sm btn-primary"
  onClick={() => {

    fetchTransactions(
      clientData.id,
      selectedParty?.mobile,
      selectedParty?.id,
      fromDate,
      toDate
    );

  }}
>
  Filter
</button>
      </div>

      {/* TABLE */}
      <div className="table-responsive">
        <table className="table table-hover">
          <thead className="table-dark text-white">
            <tr>
              <th>Bill Type</th>
              <th>Date</th>
              <th>Total</th>
              <th>Due</th>
              <th>Status</th>
              <th>Activity</th>
            </tr>
          </thead>

          <tbody>
            {transactions?.length > 0 ? (
              transactions.map((t, i) => (
                <tr key={i}>
                  <td>{t.billType}</td>
                  <td>{t.date}</td>
                  <td>₹{t.received || t.amount}</td>
                  <td>₹{t.due || "0"  }</td>
                  <td>{t.status}</td>
                  {/* <td>
                    <div className="dropdown">
                      <button
                        className="btn btn-sm btn-light"
                        data-bs-toggle="dropdown"
                      >
                        ⋮
                      </button>

                      <ul className="dropdown-menu">
                        <li>
                          <button className="dropdown-item">
                            Edit Status
                          </button>
                        </li>
                        <li>
                          <button className="dropdown-item">
                            Edit Sale
                          </button>
                        </li>
                      </ul>

                    </div>
                  </td> */}


                  <td>

  {String(t.status).toLowerCase() === "due" ? (

    <button
      className="btn btn-sm btn-success"
      onClick={() => openReceivePayment(t)}
    >
      Receive Payment
    </button>

  ) : (

    <div className="dropdown">

      <button
        className="btn btn-sm btn-light"
        data-bs-toggle="dropdown"
      >
        ⋮
      </button>

      <ul className="dropdown-menu">

        <li>
          <button className="dropdown-item">
            Edit Status
          </button>
        </li>

        {t.billType === "Sale" && (
          <li>
            <button className="dropdown-item">
              Edit Sale
            </button>
          </li>
        )}

      </ul>

    </div>

  )}

</td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="6"
                  className="text-center text-muted"
                >
                  No Transactions Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  </div>
)}



{showPaymentModal && selectedTransaction && (

  <div
    className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
    style={{
      background: "rgba(0,0,0,0.6)",
      zIndex: 10000
    }}
  >

    <div
      className="bg-white rounded-4 shadow p-4"
      style={{
        width: "90%",
        maxWidth: "400px"
      }}
    >

      {/* HEADER */}

      <div className="text-center mb-3">

        <h4 className="fw-bold mb-2">
          Payment In
        </h4>

        <div className="fw-bold">
          Due Amount: ₹
          {Number(
            selectedTransaction.due || 0
          ).toFixed(2)}
        </div>

      </div>


      {/* DATE */}

      <div className="mb-3">

        <label className="form-label fw-semibold">
          Date
        </label>

        <input
          type="date"
          className="form-control"
          value={paymentData.date}
          onChange={(e) =>
            setPaymentData({
              ...paymentData,
              date: e.target.value
            })
          }
        />

      </div>


      {/* AMOUNT */}

      <div className="mb-3">

        <label className="form-label fw-semibold">
          Amount
        </label>

        <input
          type="number"
          className="form-control"
          placeholder="Enter Here"
          value={paymentData.amount}
          max={Number(
            selectedTransaction.due || 0
          )}
          onChange={(e) => {

            let value = e.target.value;

            const due = Number(
              selectedTransaction.due || 0
            );

            if (Number(value) > due) {
              value = due;
            }

            setPaymentData({
              ...paymentData,
              amount: value
            });

          }}
        />

      </div>


      {/* PAYMENT METHOD */}

      <div className="mb-4">

        <label className="form-label fw-semibold">
          Payment Method
        </label>

        <select
          className="form-select"
          value={paymentData.payment_method}
          onChange={(e) =>
            setPaymentData({
              ...paymentData,
              payment_method: e.target.value
            })
          }
        >

          <option value="">
            Payment Method
          </option>

          <option value="Cash">
            Cash
          </option>

          <option value="UPI">
             UPI
          </option>

          <option value="Credit Card">
          Credit Card
          </option>

          <option value="Debit Card">
           Debit Card
          </option>

        </select>

      </div>


      {/* BUTTONS */}

      <div className="d-flex justify-content-end gap-2">

        <button
          type="button"
          className="btn btn-danger"
          onClick={() => {
            setShowPaymentModal(false);
            setSelectedTransaction(null);
          }}
          disabled={paymentLoading}
        >
          Cancel
        </button>


        <button
          type="button"
          className="btn btn-success"
          onClick={handleReceivePayment}
          disabled={paymentLoading}
        >

          {paymentLoading
            ? "Submitting..."
            : "Submit"}

        </button>

      </div>

    </div>

  </div>

)}

      </div>

     
     <DeleteConfirmation
  show={showDelete}
  title="Delete Party"
  message={`Are you sure you want to delete "${selectedParty?.name}"? This action cannot be undone.`}
  onConfirm={handleDelete }
  onCancel={() => setShowDelete(false)}
/>
      
    </div>
  );
};

export default Party;



